var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoLogsPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.898,
    height: 19.401,
    viewBox: "0 0 19.898 19.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDF_icon",
    "data-name": "PDF icon",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53468",
    "data-name": "Path 53468",
    d: "M45.159,576.691V562.9a.709.709,0,0,0,.037-.123,3.022,3.022,0,0,1,2.215-2.579c.133-.036.266-.068.4-.1H55.8c.04.015.079.033.121.044a2.632,2.632,0,0,1,1.254.7c1.086,1.1,2.188,2.187,3.276,3.286a2.243,2.243,0,0,1,.671,1.619q.008,5.38,0,10.76a3.017,3.017,0,0,1-2.99,2.993H48.2a2.983,2.983,0,0,1-2.813-1.93A7.856,7.856,0,0,1,45.159,576.691ZM46.7,569.8q0,3.316,0,6.631a1.583,1.583,0,0,0,.022.32,1.522,1.522,0,0,0,1.592,1.231q4.829.006,9.658-.005a1.872,1.872,0,0,0,.768-.16,1.524,1.524,0,0,0,.867-1.53q-.01-5.191,0-10.383c0-.063,0-.126,0-.189,0-.153-.059-.219-.229-.215-.543.011-1.086.006-1.629,0a2.189,2.189,0,0,1-2.168-2.174q0-.739,0-1.478c0-.246,0-.247-.245-.247H49.047c-.3,0-.594-.006-.89.009a1.5,1.5,0,0,0-1.453,1.535Q46.7,566.473,46.7,569.8Z",
    transform: "translate(-45.159 -560.091)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6569",
    "data-name": "Group 6569",
    transform: "translate(4.85 7.702)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1197",
    "data-name": "Rectangle 1197",
    width: 15.048,
    height: 8.084,
    rx: 2,
    transform: "translate(0 0)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    transform: "translate(2.213 5.404)",
    fill: "#fff",
    fontSize: 5,
    fontFamily: "SF Pro",
    fontWeight: 600,
    letterSpacing: "0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLogsPdf);
export default __webpack_public_path__ + "static/media/video_logs_pdf.6f55206e642a8bb4046cac5d4ecf2042.svg";
export { ForwardRef as ReactComponent };